import axios from "axios";
import { auditPost } from "../api/config";

const api = axios.create({
	baseURL: process.env.REACT_APP_AUTH_URL,
	withCredentials: true,
});

// const refreshApi = axios.create({
// 	baseURL: process.env.REACT_APP_AUTH_URL,
// 	timeout: 1000 * 30,
// 	headers: {},
// });

const encodeUTF8 = (str) => new TextEncoder().encode(str);

const encryptData = async (data, secretKey) => {
	const iv = window.crypto.getRandomValues(new Uint8Array(16));

	const key = await window.crypto.subtle.importKey(
		"raw",
		encodeUTF8(secretKey),
		{ name: "AES-CBC" },
		false,
		["encrypt"]
	);

	const encryptedData = await window.crypto.subtle.encrypt(
		{
			name: "AES-CBC",
			iv: iv,
		},
		key,
		encodeUTF8(data)
	);

	// Concatenar IV y datos cifrados en un solo array
	const combined = new Uint8Array(iv.length + encryptedData.byteLength);
	combined.set(iv);
	combined.set(new Uint8Array(encryptedData), iv.length);

	return btoa(String.fromCharCode(...combined)); // Codificar en base64
};

// handleAuthError: limpia el almacenamiento y establece la autenticación como falsa
const handleAuthError = (setAuthenticated) => {
	setAuthenticated(false);
};

const logging = async (
	event,
	setLoading,
	username,
	password,
	setAuthenticated,
	getModuleId,
	setCredentialsError,
	isEmbedded
) => {
	event.preventDefault();
	setLoading(true);

	// Si está embebido, saltar el login
	if (isEmbedded) {
		setAuthenticated(true);
		setLoading(false);
		return;
	}

	const headers = {
		"Content-Type": "application/x-www-form-urlencoded",
		Accept: "application/json",
	};

	const secretKey = process.env.REACT_APP_SECRET_KEY;

	try {
		const encryptedUsername = await encryptData(username, secretKey);
		const encryptedPassword = await encryptData(password, secretKey);

		const data = new URLSearchParams();
		data.append("username", encryptedUsername);
		data.append("password", encryptedPassword);

		// const token = new URLSearchParams();
		// token.append("username", username);
		// token.append("password", password);

		// Enviar las credenciales al endpoint
		const response = await api.post(`/user/token`, data, { headers });
		const dataResponse = response.data;
		if (dataResponse.access_token) {
			sessionStorage.setItem("access_token", dataResponse.access_token);
		}

		if (response.status === 200) {
			setAuthenticated(true);
			setLoading(false);
			setCredentialsError({ error: false, message: "" });
			// const moduleId = getModuleId("Login", "Login");
			// auditPost(moduleId);
		} else {
			handleAuthError(setAuthenticated);
			setLoading(false);
		}
	} catch (error) {
		setCredentialsError({
			error: true,
			message: "Usuario o contraseña incorrectos",
		});
		console.error("Error durante el inicio de sesión:", error);
		handleAuthError(setAuthenticated);
		setLoading(false);
	}
};

const checkSession = async (setAuthenticated, getModuleId, site_id) => {
	try {
		// Hacer una solicitud al backend para verificar si la sesión es válida
		const response = await api.get(`/user/current`);
		if (response.status === 200) {
			// La sesión sigue siendo válida
			setAuthenticated(true);
		} else {
			// La sesión no es válida
			handleAuthError(setAuthenticated);
			const moduleId = getModuleId("Login", "Log Out");
			auditPost(moduleId, site_id);
		}
	} catch (error) {
		console.error("Error al verificar la sesión:", error);
		handleAuthError(setAuthenticated);
		const moduleId = getModuleId("Login", "Log Out");
		auditPost(moduleId, site_id);
	}
};

api.interceptors.response.use(
	(r) => r,
	(error) => {
		if (error.response && error.response.status === 401) {
			handleAuthError(); // <-- sin pasar setAuthenticated
		}
		return Promise.reject(error);
	}
);

// const refreshTokenAutomatically = async (setAuthenticated, getModuleId) => {
// 	const decodedExp = moment(JSON.parse(sessionStorage.getItem("at_expire")));
// 	const now = moment();

// 	const expiresInMilliseconds = decodedExp.diff(now);

// 	if (expiresInMilliseconds > 0) {
// 		setTimeout(async () => {
// 			try {
// 				await refreshToken(setAuthenticated, getModuleId);
// 				refreshTokenAutomatically(setAuthenticated, getModuleId);
// 			} catch (error) {
// 				console.error("Error al actualizar el token:", error);
// 				if (error.response && error.response.status === 401) {
// 					sessionStorage.clear();
// 					handleAuthError(setAuthenticated);
// 				}
// 			}
// 		}, expiresInMilliseconds);
// 	} else {
// 		try {
// 			await refreshToken(setAuthenticated, getModuleId);
// 			refreshTokenAutomatically(setAuthenticated, getModuleId);
// 		} catch (error) {
// 			console.error("Error al actualizar el token:", error);
// 			if (error.response && error.response.status === 401) {
// 				sessionStorage.clear();
// 				handleAuthError(setAuthenticated);
// 			}
// 		}
// 	}
// };

// const isTokenExpired = () => {
// 	const expireTime = JSON.parse(sessionStorage.getItem("at_expire"));
// 	return moment().isAfter(moment(expireTime));
// };

// const refreshToken = async (setAuthenticated, getModuleId) => {
// 	const refreshToken = sessionStorage.getItem("refresh_token");

// 	if (!refreshToken) {
// 		handleAuthError(setAuthenticated);
// 		const moduleId = getModuleId("Login", "Log Out");
// 		auditPost(moduleId, sessionStorage.getItem("access_token"));
// 		sessionStorage.clear();
// 		throw new Error("No hay token de refresco disponible");
// 	}

// 	try {
// 		const response = await refreshApi.post("/user/token/refresh?refresh_token=" + refreshToken);
// 		const data = response.data;

// 		if (data.access_token) {
// 			//remover el token actual

// 			sessionStorage.removeItem("access_token");
// 			sessionStorage.removeItem("at_expire");

// 			//guardar el nuevo token
// 			const decoded = jwtDecode(data.access_token);
// 			sessionStorage.setItem("access_token", data.access_token);
// 			sessionStorage.setItem("at_expire", JSON.stringify(moment.unix(decoded.exp).toDate()));

// 			api.defaults.headers.Authorization = `Bearer ${data.access_token}`;

// 			return data.access_token;
// 		} else {
// 			const moduleId = getModuleId("Login", "Log Out");
// 			auditPost(moduleId, sessionStorage.getItem("access_token"));
// 			handleAuthError(setAuthenticated);
// 			sessionStorage.clear();
// 			throw new Error("Error al refrescar el token");
// 		}
// 	} catch (error) {
// 		if (error.response && error.response.status === 401) {
// 			const moduleId = getModuleId("Login", "Log Out");
// 			auditPost(moduleId, sessionStorage.getItem("access_token"));
// 			handleAuthError(setAuthenticated);
// 			sessionStorage.clear();
// 		}
// 		console.error("Error al refrescar el token:", error);
// 		throw error;
// 	}
// };

// api.interceptors.request.use(
// 	async (config) => {
// 		if (isTokenExpired()) {
// 			await refreshToken();
// 			config.headers.Authorization = `Bearer ${sessionStorage.getItem("access_token")}`;
// 		}
// 		return config;
// 	},
// 	(error) => Promise.reject(error)
// );

const validateUsername = (username) => {
	const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
	return regex.test(username);
};

const validatePassword = (password) => {
	const regex = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
	return regex.test(password);
};

export { validateUsername, validatePassword, logging, checkSession };
